import { useSubscription } from '@hotjar/webapp/hooks/useSubscription';
import { useCurrentSite } from '@hotjar/site';
import type { ForwardToZapierProps } from './ForwardToZapier';
import { ForwardToZapier } from './ForwardToZapier';

type ForwardToZapierConnectedProps = Omit<ForwardToZapierProps, 'site' | 'upsell'>;

export const ForwardToZapierConnected = (
  props: ForwardToZapierConnectedProps,
): JSX.Element | null => {
  const { data: currentSite } = useCurrentSite();
  const { upsell } = useSubscription();

  // eslint-disable-next-line react/jsx-props-no-spreading
  return currentSite ? <ForwardToZapier {...props} site={currentSite} upsell={upsell} /> : null;
};
